<template>
    <div>
        <div>{{ this.$t('components.miscellaneous.addNewSchoolDialog.content') }}</div>
        <div class="add-school-btns">
            <BaseButton class="add-school-btn" variant="primary" block @click="confirm">
                {{ 'Confirm' }}
            </BaseButton>
            <BaseButton class="add-school-btn" variant="outline-primary" block @click="cancel">
                {{ 'Check again' }}
            </BaseButton>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AddNewSchoolDialog',
    methods: {
        cancel() {
            this.$emit('close', { result: 'canceled' });
        },
        confirm() {
            this.$emit('close', { result: 'confirmed' });
        },
    },
};
</script>

<style>
.add-school-btns {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin: 1.5rem 0 1rem 0;
}

.add-school-btn {
    width: 150px;
}
</style>
